import { render, staticRenderFns } from "./CargoTypeSelector.vue?vue&type=template&id=8d307ce6"
import script from "./CargoTypeSelector.vue?vue&type=script&lang=js"
export * from "./CargoTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports